export var MessageTemplateStatus;
(function (MessageTemplateStatus) {
    MessageTemplateStatus["Approved"] = "APPROVED";
    MessageTemplateStatus["Pending"] = "PENDING";
    MessageTemplateStatus["Rejected"] = "REJECTED";
    MessageTemplateStatus["PendingDeletion"] = "PENDING_DELETION";
    MessageTemplateStatus["InAppeal"] = "IN_APPEAL";
    MessageTemplateStatus["Deleted"] = "DELETED";
    MessageTemplateStatus["Disabled"] = "DISABLED";
    MessageTemplateStatus["Paused"] = "PAUSED";
    MessageTemplateStatus["LimitExceeded"] = "LIMIT_EXCEEDED";
})(MessageTemplateStatus || (MessageTemplateStatus = {}));
